<ng-container>
  <fa-icon [icon]="icons['chevronUp']"/>
</ng-container>
